define.alias("shared/components/shared/post/secondary/activity/footer", "calendar/components/shared/post/secondary/activity/footer");